import React from "react";
import APIGateway from "../DevicesPage/DevicesComponents/ApiGateway.tsx";
import DoorSensor from "../DevicesPage/DevicesComponents/DoorSensor.tsx";
import EnvData from "../DevicesPage/DevicesComponents/EnvData.tsx";
import PushButton from "../DevicesPage/DevicesComponents/PushButton.tsx";
import { useMediaQuery } from '@mui/material';

const Devices = ({ activeComponent, setActiveComponent, apiGatewayRef, pushButtonRef, envDataRef, doorSensorRef }: any) => {

  const isMobile = useMediaQuery('(max-width:900px)');

  const renderComponent = () => {
    switch (activeComponent) {
      case "API Gateway":
        return <APIGateway />
      case "Push Button":
        return <PushButton />
      case "Environment Data":
        return <EnvData />
      case "Door Sensor":
        return <DoorSensor />
      default:
        return <APIGateway />
    }
  }

  const handleClick = (event: any) => {
    const selectedComponent = event.target.innerText;
    if (selectedComponent !== activeComponent) {
      setActiveComponent(selectedComponent);
    }
  }

  const navItems = [
    { label: "API Gateway", ref: apiGatewayRef },
    { label: "Push Button", ref: pushButtonRef },
  ];

  return (
    <div className="flex w-full bg-[rgb(var(--surface-1))] border border-[rgb(var(--border-primary))] rounded-lg overflow-hidden min-h-[500px] max-md:flex-col max-md:min-h-0">

      {/* Mobile tabs */}
      <div className="hidden max-md:flex gap-1 p-3 border-b border-[rgb(var(--border-primary))] overflow-x-auto">
        {navItems.map((item) => (
          <button
            key={item.label}
            ref={item.ref}
            onClick={handleClick}
            className={`
              px-3.5 py-2 rounded-md text-[12px] font-medium whitespace-nowrap transition-all duration-200
              ${activeComponent === item.label
                ? "bg-gold-2/10 text-gold-2 font-semibold"
                : "text-[rgb(var(--text-secondary))] hover:bg-[rgb(var(--surface-2))]"
              }
            `}
          >
            {item.label}
          </button>
        ))}
      </div>

      {/* Desktop sidebar */}
      {!isMobile && (
        <div className="w-[200px] min-w-[200px] py-4 border-r border-[rgb(var(--border-primary))] flex flex-col gap-0.5">
          {navItems.map((item) => (
            <div
              key={item.label}
              ref={item.ref}
              onClick={handleClick}
              className={`
                px-5 py-2.5 text-[13px] font-medium cursor-pointer transition-all duration-200 border-l-[3px]
                ${activeComponent === item.label
                  ? "text-gold-2 font-semibold bg-gold-2/[0.06] border-l-gold-2"
                  : "text-[rgb(var(--text-secondary))] hover:text-[rgb(var(--text-primary))] hover:bg-[rgb(var(--surface-2))] border-l-transparent"
                }
              `}
            >
              <span className="overflow-hidden text-ellipsis whitespace-nowrap">{item.label}</span>
            </div>
          ))}
        </div>
      )}

      {/* Content */}
      <div className="flex-1 p-6 overflow-y-auto max-h-[calc(100vh-200px)] max-md:p-4 max-md:max-h-none">
        {renderComponent()}
      </div>
    </div>
  );
}

export default Devices;
